/**
 * Link alla cartella dove carichi i biglietti (es. Google Drive).
 * Imposta l'URL quando hai i PDF/screen dei voucher.
 *
 * Esempio:
 * export const TICKET_STORAGE_URL = 'https://drive.google.com/drive/folders/...';
 */
export const TICKET_STORAGE_URL = null;

export const TICKET_STORAGE_LABEL = 'Apri i miei biglietti';
